/*@flow*/
import useFilters from './useFilters';
import sectionNames from './sectionNames';
import cleanQuery from 'lib/cleanQuery';

export default function useHasFilters(): boolean {
  const filters = useFilters();
  const cleanedQueries = cleanQuery(
    filters
      .filter((_, k) => sectionNames.includes(k))
      .map((v) => cleanQuery(v.toJS()))
      .toJS()
  );
  return Object.keys(cleanedQueries).length > 0;
}
